import { Component, inject } from '@angular/core';
import { ResourcesPageFacade } from './resources-page.facade';

@Component({
  selector: 'app-equipment',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
  providers: [ResourcesPageFacade],
  standalone: false,
})
export class ResourcesComponent {
  readonly page = inject(ResourcesPageFacade);
}
